import { Button } from 'uikit'
import { Field, Formik } from 'formik'
import { isEmpty } from 'lodash'
import { useMemo } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Heading, InputForm, SelectForm, TextAreaForm } from 'uikit'
import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  Form,
  FormGrid,
  FormLabel,
  FormSection,
  HeadingContainer,
} from 'uikit/layout'
import * as Yup from 'yup'
import { catalogEntryTypeOptions } from './Item.constants'
import { Delete } from './components/Delete/Delete'
import { useCreateCatalogItem } from './services/useCreateCatalogItem'
import { useFetchCatalogItem } from './services/useFetchCatalogItem'
import { useFetchEventsCodeOptions } from './services/useFetchEventsCodeOptions'
import { useUpdateCatalogItem } from './services/useUpdateCatalogItem'

const formSchema = Yup.object().shape({
  eventCode: Yup.string().required('Обязательное поле'),
  referralReward: Yup.string().test('reward', 'Заполните поле', (e) => !Number(isNaN(e) || e < 0)),
  referrerReward: Yup.string().test('reward', 'Заполните поле', (e) => !Number(isNaN(e) || e < 0)),
})

export const Item = () => {
  const history = useHistory()
  const { id } = useParams()
  const isNew = !id

  const { data, isPending: isLoadingFetchItem } = useFetchCatalogItem(id)
  const { mutate: createItem, isPending: isLoadingCreateItem } = useCreateCatalogItem()
  const { mutate: updateItem, isPending: isLoadingUpdateItem } = useUpdateCatalogItem(id)
  const { data: catalogData, isPending: isLoadingOptions } = useFetchEventsCodeOptions()
  const optionsCode = catalogData?.map((e) => e.eventCode)

  const options = useMemo(() => {
    if (isEmpty(optionsCode)) {
      return []
    }
    return [
      {
        label: 'Нет',
        value: null,
      },
      ...(optionsCode?.map((e) => ({
        label: e,
        value: e,
      })) ?? []),
    ]
  }, [optionsCode])

  const isLoading = isLoadingFetchItem || isLoadingCreateItem || isLoadingUpdateItem
  const isReadOnly = isLoading

  const handleBack = () => {
    history.goBack()
  }

  const handleForm = (values) => {
    const payload = {
      ...values,
      referralReward: Number(values?.referralReward),
      referrerReward: Number(values?.referrerReward),
      count: Number(values?.count),
      catalogEntryType: values.catalogEntryType || null,
      amount: values.amount || null,
    }

    if (isNew) {
      createItem(payload, {
        onSuccess: () => {
          handleBack()
        },
      })
    } else {
      updateItem(payload, {
        onSuccess: () => {
          handleBack()
        },
      })
    }
  }

  return (
    <Container>
      <CardContainer onBack={handleBack} indentTop={120}>
        <ContentContainer>
          <ContentContainerColumn>
            <HeadingContainer>
              <Heading>{isNew ? 'Создание события' : 'Обновление события'}</Heading>
              {!isNew && <Delete id={id} />}
            </HeadingContainer>
            <Formik
              initialValues={{
                eventCode: data?.eventCode,
                description: data?.description,
                relatedEvents: data?.relatedEvents,
                referralReward: String(data?.referralReward ?? 0),
                referrerReward: String(data?.referrerReward ?? 0),
                count: String(data?.count ?? 0),
                catalogEntryType: data?.catalogEntryType,
                amount: data?.amount,
              }}
              enableReinitialize
              onSubmit={handleForm}
              validationSchema={formSchema}
            >
              {(formProps) => (
                <Form
                  onSubmit={formProps.handleSubmit}
                  {...(!isReadOnly && {
                    footer: (
                      <Button
                        type="submit"
                        colorPalette="orange"
                        loading={isLoading}
                        disabled={!formProps.isValid}
                      >
                        {isNew ? 'Создать' : 'Обновить'}
                      </Button>
                    ),
                  })}
                >
                  <FormSection>
                    <Field
                      name="eventCode"
                      component={InputForm}
                      label="Код"
                      isReadOnly={!isNew}
                      disabled={isLoading}
                    />
                    <Field
                      name="description"
                      component={TextAreaForm}
                      label="Описание"
                      isReadOnly={isReadOnly}
                      disabled={isLoading}
                    />
                    <Field
                      disabled={isLoading || isReadOnly}
                      name="relatedEvents"
                      label="Зависимое событие"
                      component={SelectForm}
                      placeholder="Выберите ..."
                      options={options}
                    />
                    <FormGrid columns={2}>
                      <Field
                        name="referralReward"
                        component={InputForm}
                        label="Вознаграждение"
                        isReadOnly={isReadOnly}
                        disabled={isLoading}
                      />
                      <Field
                        name="referrerReward"
                        component={InputForm}
                        label="Вознаграждение реферера"
                        isReadOnly={isReadOnly}
                        disabled={isLoading}
                      />
                    </FormGrid>
                    <Field
                      name="count"
                      component={InputForm}
                      label="Курс перевода бонусов в деньги"
                      isReadOnly={isReadOnly}
                      disabled={isLoading}
                    />

                    <FormLabel>
                      Настройка суммы выплат (заполнять для события выплат бонусов)
                    </FormLabel>
                    <Field
                      name="catalogEntryType"
                      component={SelectForm}
                      label="Тип платежа"
                      placeholder="Выберите тип платежа"
                      isReadOnly={isReadOnly}
                      disabled={isLoading}
                      options={catalogEntryTypeOptions}
                      isClearable
                    />
                    <Field
                      name="amount"
                      component={InputForm}
                      type="number"
                      label="Сумма выплат"
                      placeholder="Введите сумму выплат"
                      isReadOnly={isReadOnly}
                      disabled={isLoading}
                    />
                  </FormSection>
                </Form>
              )}
            </Formik>
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>
    </Container>
  )
}
